export default "/images/87052db30e28731983998a41e6f59181.avif";